import { useEffect, useState, useMemo } from "react";
import Campaign from "../Entities/Campaign.tsx";

interface Props {
  campaigns: Campaign[];
}

const CampaignCarousel = ({ campaigns }: Props) => {
  // Sadece ShowBannerImage true olan kampanyalar
  const visibleCampaigns = useMemo(
    () => campaigns.filter((c) => c.showBannerImage),
    [campaigns]
  );

  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (visibleCampaigns.length <= 1) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % visibleCampaigns.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [visibleCampaigns]);

  // Eğer kampanya yoksa varsayılan banner döndür
  if (visibleCampaigns.length === 0) {
    return (
      <div className="relative w-full h-64 rounded-lg overflow-hidden shadow-md mb-8">
        <img
          src={`${process.env.REACT_APP_API_URL}/uploads/campaigns/default_banner.png`}
          alt="Genel Kampanya"
          className="w-full h-full"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center flex-col text-center p-4">
          <h2 className="text-3xl font-bold text-white mb-2">
            Fırsatları Kaçırma!
          </h2>
          <p className="text-white">
            En yeni kampanyalar ve indirimler için bizi takip edin.
          </p>
        </div>
      </div>
    );
  }

  const campaign = visibleCampaigns[index];

  return (
    <div className="relative w-full h-64 rounded-lg overflow-hidden shadow-md mb-8">
      <img
        src={
          campaign.bannerImageUrl
            ? `${process.env.REACT_APP_API_URL}${campaign.bannerImageUrl}`
            : `${process.env.REACT_APP_API_URL}/images/default-banner.jpg`
        }
        alt={campaign.name}
        className="w-full h-full"
      />
      {/* object-cover */}
      <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center flex-col text-center p-4">
        <h2 className="text-3xl font-bold text-white mb-2">{campaign.name}</h2>
        <span className="mt-2 bg-white text-black px-4 py-1 rounded-full font-semibold">
          %{campaign.discountRate} indirim
        </span>
      </div>
      <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-2">
        {visibleCampaigns.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`w-3 h-3 rounded-full ${index === i ? "bg-white" : "bg-gray-400"
              }`}
          />
        ))}
      </div>
    </div>
  );
};

export default CampaignCarousel;
